import React from 'react';
// @ts-ignore
import styles from './PatientProfileBadge.module.scss';

interface Props {
	partner: string;
}

const PatientProfileBadge: React.FC<Props> = ({ partner }) => {
	return <div className={styles.wrapper}>{partner}</div>;
};

export default PatientProfileBadge;
